import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import data from "./ModalContent.json";
import styles from "./ModalManager.module.css";
import { setCurrentModule } from "../../store/reducers/progressionReducer";
import SideModal from "./SideModal/SideModal";
import MainVideoModal from "./MainVideoModal/MainVideoModal";
import FlyingModal from "./FlyingModal/FlyingModal";
import bcrypt from "bcryptjs"
import secuIssue from "../Login/security_issue.json"
import VideoListModal from "./VideoListModal/VideoListModal";
import FilteredModal from "./FilteredModal/FilteredModal";
import MainVideoModalRight from "./MainVideoModal/MainVideoModalRight";

export default function ModalManager() {
  const currentModule = useSelector((state) => state.progression.currentModule);
  const activeModals = useSelector((state) => state.progression.activeModals);
  const currentState = useSelector((state) => state.progression.currentState);
  const [displayedContent, setDisplayedContent] = useState(null);
  const [mdpHashed, setMdpHashed] = useState(null);
  const [isSafariIOS, setIsSafariIOS] = useState(false);
  const dispatch = useDispatch();

  // Détection de Safari iOS
  useEffect(() => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (isSafari && isIOS) {
      setIsSafariIOS(true);
      document.body.classList.add('ios-safari');
    } else {
      document.body.classList.remove('ios-safari');
    }

    return () => {
      document.body.classList.remove('ios-safari');
    };
  }, []);

  // Fonction pour fermer une modale en cliquant à l'extérieur
  const handleOutsideClick = (e) => {
    // Si l'utilisateur clique directement sur la div parente (modalFrame), fermer la modale
    if (e.target.className === styles.modalFrame) {
      dispatch(setCurrentModule("none"));
    }
  };

  useEffect(() => {
    document.addEventListener("dblclick", () => {
      dispatch(setCurrentModule("Tools"));
    });

    // Ajouter l'écouteur d'événement pour les clics
    document.addEventListener("click", handleOutsideClick);

    // Nettoyer l'écouteur d'événement lors du démontage
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (secuIssue) {

    }
    else {
      /*  const salt = bcrypt.hash("saviolAS2024",secuIssue.salt).then((v) => {
          setMdpHashed(v)
          console.log(v)
        });*/
    }
  }, [mdpHashed])

  // Fix pour Safari iOS - Empêcher le défilement du body quand une modale est ouverte
  useEffect(() => {
    if (currentModule !== "none" && isSafariIOS) {
      // Sauvegarder la position de défilement actuelle
      const scrollY = window.scrollY;

      // Appliquer un style pour fixer le body
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${scrollY}px`;

      return () => {
        // Restaurer le défilement normal
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        window.scrollTo(0, scrollY);
      };
    }
  }, [currentModule, isSafariIOS]);

  useEffect(() => {
    if (currentModule === "none" && activeModals.length === 0) {
      setDisplayedContent(null);
    } else {
      let content = [];

      // Gérer le currentModule principal
      if (currentModule !== "none") {
        const modalProps = typeof currentModule === 'object'
          ? currentModule
          : data[currentState][currentModule];

        if (modalProps?.type) {
          switch (modalProps.type) {
            case "flyingModal":
              content.push(<FlyingModal key="flying" {...modalProps} />);
              break;
            case "mainVideoModal":
              content.push(
                <MainVideoModal key="mainVideo" {...modalProps}></MainVideoModal>,
              );
              break;
            case "videoListModal":
              content.push(
                <VideoListModal key="videoList" {...modalProps}></VideoListModal>
              );
              break;
            case "sideModal":
              content.push(<SideModal key="side" {...modalProps}></SideModal>);
              break;
            case "filteredModal":
              content.push(<FilteredModal key="filtered" {...modalProps}></FilteredModal>)
              break;
            default:
              console.warn("Unknown modal type:", modalProps.type);
          }
        } else {
          console.warn("No modal props found for currentModule:", currentModule);
        }
      }

      // Ajouter les modales vidéo actives
      activeModals.forEach((modalProps, index) => {
        if (modalProps.type === "mainVideoModalRight") {
          content.push(
            <MainVideoModalRight
              key={`videoRight-${index}`}
              {...modalProps}
            />
          );
        }
      });

      setDisplayedContent(<>{content}</>);
    }
  }, [currentModule, currentState, activeModals, isSafariIOS]);

  // Ne rendre le modalFrame que si nous avons du contenu à afficher
  if (!displayedContent) {
    return null;
  }

  // Style inline pour s'assurer que le contenu est visible
  const modalFrameStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitOverflowScrolling: 'touch',
    ...isSafariIOS ? { WebkitOverflowScrolling: 'touch' } : {}
  };

  return (
    <div
      className={`${styles.modalFrame} ${isSafariIOS ? 'ios-safari-modal' : ''}`}
      style={modalFrameStyle}
    >
      {displayedContent}
    </div>
  );
}
